import { apiClient } from './client';

export interface GeneratedStatement {
  id: string;
  user_id: string;
  statement_type: string;
  period_start: string;
  period_end: string;
  status: 'pending' | 'completed' | 'failed';
  file_path: string | null;
  error_message: string | null;
  created_at: string;
  updated_at: string;
}

export interface MonthlyStatementParams {
  year: number;
  month: number;
}

export const statementEndpoints = {
  listStatements: async (): Promise<GeneratedStatement[]> => {
    const response = await apiClient.get('/api/me/statements');
    return response.statements || [];
  },

  createMonthlyStatement: async (params: MonthlyStatementParams): Promise<GeneratedStatement> => {
    const response = await apiClient.post('/api/me/statements/monthly', params);
    return response.statement;
  },

  downloadStatement: async (statementId: string): Promise<Blob> => {
    const blob = await apiClient.get(`/api/me/statements/${statementId}/download`, {
      responseType: 'blob',
    });
    return blob;
  },
};
